/**
 * @generated SignedSource<<d0041189c6e6143e977ae53580e3d5dd>>
 * @relayHash e0cfbeec7ab21c4537cc345b57415164
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 751f380d183acb8583bba4ad6166f3ef0ff8802f77c9de73c1817f5dd54c1ccd

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4FiltersContentViewQuery$variables = {
  cloudId: string;
  currentURL?: AGG$URL | null;
  entityAriFilters: string;
  ownerAri: string;
  skipOrderQuery: boolean;
};
export type Nav4FiltersContentViewQuery$data = {
  readonly filtersOrder?: {
    readonly " $fragmentSpreads": FragmentRefs<"Nav4FiltersContent_navigationCustomisation">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FiltersContent">;
};
export type Nav4FiltersContentViewQuery = {
  response: Nav4FiltersContentViewQuery$data;
  variables: Nav4FiltersContentViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentURL"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipOrderQuery"
},
v5 = {
  "kind": "Variable",
  "name": "currentURL",
  "variableName": "currentURL"
},
v6 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "entityAriFilters"
  },
  {
    "kind": "Variable",
    "name": "ownerAri",
    "variableName": "ownerAri"
  }
],
v7 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v9/*: any*/)
      ]
    }
  ],
  "type": "JiraCustomFilter"
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v15 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "Nav4FiltersContentViewQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "Nav4FiltersContent"
      },
      {
        "condition": "skipOrderQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "filtersOrder",
            "args": (v6/*: any*/),
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "Nav4FiltersContent_navigationCustomisation"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "Nav4FiltersContentViewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "favouriteFilters",
            "args": [
              (v7/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "sort": {
                    "order": "DESC"
                  },
                  "type": "FILTER"
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 15
              }
            ],
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "concreteType": "JiraFavouriteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "type": "JiraFilter",
                        "abstractKey": "__isJiraFilter"
                      },
                      (v14/*: any*/)
                    ]
                  }
                ]
              },
              (v15/*: any*/)
            ]
          },
          {
            "alias": "recentFilters",
            "args": [
              (v7/*: any*/),
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              },
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "FILTER"
                ]
              }
            ],
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "recentItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v9/*: any*/),
                          (v11/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v12/*: any*/),
                              (v13/*: any*/)
                            ],
                            "type": "JiraFilter",
                            "abstractKey": "__isJiraFilter"
                          }
                        ],
                        "type": "JiraCustomFilter"
                      },
                      (v14/*: any*/)
                    ]
                  }
                ]
              },
              (v15/*: any*/)
            ]
          },
          {
            "args": [
              (v7/*: any*/)
            ],
            "concreteType": "JiraSystemFilterConnection",
            "kind": "LinkedField",
            "name": "systemFilters",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSystemFilterEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraSystemFilter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          (v8/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "type": "JiraFilter",
                        "abstractKey": "__isJiraFilter"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "skipOrderQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "filtersOrder",
            "args": (v6/*: any*/),
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
              {
                "concreteType": "SettingsMenuItemConnection",
                "kind": "LinkedField",
                "name": "sidebar",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "menuId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "visible"
                      }
                    ]
                  }
                ]
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "751f380d183acb8583bba4ad6166f3ef0ff8802f77c9de73c1817f5dd54c1ccd",
    "metadata": {},
    "name": "Nav4FiltersContentViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d4b665b65964e2ddaba79547452785c6";

export default node;
